export const FIND_OPEN_ANSWER_PROCESS_STATEMENTS_FAILURE = 'FIND_OPEN_ANSWER_PROCESS_STATEMENTS_FAILURE';

export const findOpenAnswerProcessStatementsFailure = ({ error, request }) => ({
    type: FIND_OPEN_ANSWER_PROCESS_STATEMENTS_FAILURE,
    payload: error,
    error: true,
    meta: {
        request
    }
});